<template>
  <section id="home">
    <h1 class="text-uppercase text-center">
      Osteopathie in Berlin
    </h1>
    <h2 
      class="h1 text-uppercase text-center d-none d-sm-block"
    >
      Neukölln
    </h2>
    <h2 
      class="h2 text-uppercase text-center d-block d-sm-none"
    >
      Neukölln
    </h2>
    <p class="h1 text-center">
      /
    </p> 
    <a href="tel:+491797797077">
      <h2 class="text-uppercase text-center"><font-awesome-icon
        :icon="['fas', 'phone-alt']"
        class="mr-2"
      /> +49 179 7797077</h2>
    </a>
    <a href="mailto:mail@osteopathie-bruns.de">
      <h2 class="text-center"><font-awesome-icon
        :icon="['fas', 'envelope']"
        class="mr-2"
      /> mail@osteopathie-bruns.de</h2>
    </a>
  </section>
</template>
<script>
export default {
    name: "ContentHome"
}
</script>
